export default __webpack_public_path__ + "static/media/10_synxis.dee5a385.svg";